import { Box, Divider, Link } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IconHelp } from "src/components/icons-mui/help";
import { IconShieldWithCheckmark } from "src/components/icons-mui/shield-with-checkmark";
import { COUNTRY_INT } from "src/consts/locale";
import { useRouterLocale } from "src/utils/router/use-router-locale";

const CBHelpLinks = () => {
    const { t } = useTranslation("wf-detail");
    return (
        <Box display="flex" gap={2} flexDirection="column">
            <Link
                href="https://help.wikifolio.com/article/86-wie-sicher-sind-investitionen-in-wikifolio-zertifikate"
                color="blue"
                underline="hover"
                fontSize="xs"
                target="_blank"
                rel="noreferrer noopener"
                display="inline-flex"
                alignItems="center"
                gap={0.5}
                width="fit-content"
            >
                <IconShieldWithCheckmark fontSize="small" sx={{ color: "blue.700", mr: "1px", width: "16px", height: "16px" }} aria-hidden="true" />
                {t("certificate.footer.certificates-are-secured")}
            </Link>

            <Link
                href="https://help.wikifolio.com/article/83-was-genau-ist-ein-wikifolio-zertifikat"
                underline="hover"
                target="_blank"
                display="inline-flex"
                fontSize="xs"
                rel="noreferrer noopener"
                alignItems="center"
                gap={0.5}
                width="fit-content"
            >
                <IconHelp fontSize="small" sx={{ ml: "1px", color: "gray.800", width: "16px", height: "16px" }} aria-hidden="true" />
                {t("certificate.footer.what-is-a-wikifolio-certificate")}
            </Link>
        </Box>
    );
};

export const CBFooter = () => {
    const { country } = useRouterLocale();

    if (country === COUNTRY_INT) {
        return null;
    } else {
        return (
            <>
                <Divider />
                <CBHelpLinks />
            </>
        );
    }
};
